import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {UserType} from './authenticated';

export type MeetingType = {
  id: number
  hostUserId: number
  title: string
  link: string
  isLocked: false
  startsAt: string
  endsAt: string
  users: UserType[];
};

export type MeetingsType = MeetingType[];

// Stateの初期状態
const initialState: MeetingsType = [];

// Sliceを生成する
const slice = createSlice({
  name    : 'meetings',
  initialState,
  reducers: {
    set: (state, action: PayloadAction<MeetingsType>) => {
      return action.payload;
    },
  }
});

// Reducerをエクスポートする
export default slice.reducer;

// Action Creatorsをエクスポートする
export const {set} = slice.actions;
